import Api from '../../common/api/api';
import responsePayloadMixin from '../../common/api/response-payload-mixin';


class FrontendApi extends responsePayloadMixin(Api) {

}

export default FrontendApi;
